import { useState, useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { ThemeContext } from "../util/ThemeContext";
import logo from "../assets/logo.png";
import { tailChase } from "ldrs";
import API_URL from "../config/apiConfig";

tailChase.register();

// let deviceHeaders = {};

async function tryLogin({ username }) {
  //   if (typeof ZoomHelper !== "undefined") {
  //     try {
  //       const deviceInfoStr = window.ZoomHelper.getDeviceInfo();
  //       const deviceInfo = JSON.parse(deviceInfoStr);
  //       deviceHeaders = {
  //         "x-device-uuid": deviceInfo.uuid,
  //         "x-device-model": deviceInfo.model,
  //         "x-device-manufacturer": deviceInfo.manufacturer,
  //       };
  //     } catch (error) {
  //       console.error("Device info error:", error);
  //     }
  //   }

  const response = await fetch(`${API_URL}/api/redirects/check-username`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      // ...deviceHeaders,
    },
    body: JSON.stringify({ username }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Login failed.");
  }
  return response.json();
}

function LoginRedirect() {
  const [error, setError] = useState(null);
  const [username, setUsername] = useState("");
  const themeData = useContext(ThemeContext);

  const mutation = useMutation({
    mutationFn: tryLogin,
    onSuccess: (data) => {
      window.location.href = data.redirect;
    },
    onError: (error) => {
      setError(error.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({ username });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center px-4 overflow-hidden">
      {/* 🔥 Background Image */}
      <img
        src={themeData?.backgroundImageUrl}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* 🔒 Login Box */}
      <div className="relative z-10 w-full max-w-md bg-primary opacity-95 backdrop-blur-md rounded-xl shadow-xl overflow-hidden">
        <div className="relative z-20 p-8 space-y-6">
          <img
            src={themeData?.lightlogoUrl || logo}
            alt="logo"
            className="mx-auto h-24 w-24 sm:h-32 sm:w-32 md:h-40 md:w-40 lg:h-48 lg:w-48"
          />

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              id="username"
              name="username"
              type="text"
              required
              placeholder="Username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full h-12 rounded-md text-center text-base px-3 focus:outline-none"
              style={{
                backgroundColor:
                  themeData?.theme?.loginInputAreaBackgroundColor || "#fff",
                color: themeData?.theme?.loginInputTypedTextColor || "#000",
                border: `1px solid ${themeData?.theme?.primary || "#ccc"}`,
              }}
              onFocus={(e) =>
                (e.target.style.border = `1px solid ${
                  themeData?.theme?.primary || "#1777B4"
                }`)
              }
              onBlur={(e) =>
                (e.target.style.border = `1px solid ${
                  themeData?.theme?.primary || "#ccc"
                }`)
              }
            />

            <button
              type="submit"
              className="w-full bg-loginButtonColor hover:bg-loginButtonHoverColor hover:text-loginButtonHoverTextColor text-loginButtonTextColor font-semibold py-2 px-4 rounded-md"
            >
              {mutation?.isLoading ? "Logging in..." : "SUBMIT"}
            </button>
          </form>

          {error && (
            <p className="text-red-600 text-sm font-semibold text-center">
              {error}
            </p>
          )}
        </div>
      </div>
      <style jsx global>{`
        html,
        body {
          margin: 0;
          padding: 0;
          height: 100%;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}

export default LoginRedirect;
